import React from 'react'
import PropTypes from 'prop-types'

const IndexPagePreview = ({ entry, getAsset }) => {
  const data = entry.getIn(['data']).toJS()

  if (data) {
    return (
      <div class="container has-text-centered">
        <h2 className="subtitle is-3">{data.subheading}</h2>
        <div className="content has-text-weight-medium">
          <p>{data.description}</p>
        </div>
      </div>
    )
  } else {
    return <div>Loading...</div>
  }
}

IndexPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  getAsset: PropTypes.func,
}

export default IndexPagePreview
